export default "__VITE_ASSET__D2lZ_Go0__"